import { Card } from '@ovotech/nebula';
import React, { ComponentProps, ReactNode, type JSX } from 'react';
import { IconHeader } from './IconHeader';
import {
  StyledSummaryCard,
  StyledSummaryCardHeader,
  StyledSummaryCardFooter,
  StyledSummaryCardBody,
} from './SummaryCard.styled';

type Props = JSX.IntrinsicElements['div'] & {
  footer?: ReactNode;
  // Removes border and margin under header.
  condensed?: boolean;
} & ComponentProps<typeof IconHeader>;

const SummaryCard = ({
  heading,
  subtitle,
  icon,
  footer,
  children,
  condensed,
  ...rest
}: Props) => (
  <StyledSummaryCard {...rest} as={Card}>
    <IconHeader
      condensed={condensed}
      as={StyledSummaryCardHeader}
      heading={heading}
      subtitle={subtitle}
      icon={icon}
    />
    <StyledSummaryCardBody>{children}</StyledSummaryCardBody>
    {footer ? (
      <StyledSummaryCardFooter>{footer}</StyledSummaryCardFooter>
    ) : null}
  </StyledSummaryCard>
);

export { SummaryCard };
